import { Box, Typography, useTheme } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { isNotNullOrUndefined, vyDate } from '@vy/utils';
import React from 'react';

type DynamicInvoiceApprovedLabelProps = {
  approvedAt?: Date;
};

export const DynamicInvoiceApprovedLabel: React.FC<DynamicInvoiceApprovedLabelProps> = ({ approvedAt }) => {
  const vyTheme = useTheme();

  const approvalMessage = isNotNullOrUndefined(approvedAt)
    ? `${vyDate(approvedAt).format('DD.MM.YYYY HH:mm')}`
    : 'Approved';

  return (
    <Box
      sx={{
        height: "42px",
        bgcolor: vyTheme.palette.success.hover,
        padding: "6px 16px 6px 16px",
        marginLeft: "auto",
        display: "flex",
        gap: 1,
        alignItems: "center"
      }}>
      <VyIcon icon="CheckCircle" color={vyTheme.palette.success.dark} />
      <Typography
        color={vyTheme.palette.success.dark}
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "24px",
          bgcolor: "transparent"
        }}>
        {approvalMessage}
      </Typography>
    </Box>
  );
};
